/** Divider on purple (normal) WC header — readable on `theme.background.primary`. */
export const WORLD_CUP_HEADER_DIVIDER_ON_BRAND = 'rgba(255, 255, 255, 0.35)' as const;

/** Avatar size in the mobile/narrow header lead slot. */
export const WORLD_CUP_HEADER_AVATAR_SIZE = 24;

// ── Wide (desktop web ≥ 768) ──────────────────────
export const WORLD_CUP_HEADER_BUTTON_SIZE = 40;
export const WORLD_CUP_HEADER_ICON_SIZE = 22;
export const WORLD_CUP_HEADER_TROPHY_SIZE = 26;
export const WORLD_CUP_HEADER_PADDING_H = 16;

// ── Narrow (mobile native + web < 768) ─────────────
export const WORLD_CUP_HEADER_BUTTON_SIZE_NARROW = 30;
export const WORLD_CUP_HEADER_ICON_SIZE_NARROW = 18;
export const WORLD_CUP_HEADER_TROPHY_SIZE_NARROW = 20;
export const WORLD_CUP_HEADER_PADDING_H_NARROW = 12;
export const WORLD_CUP_HEADER_TRAIL_GAP_NARROW = 2;

/**
 * Lead slot when OrgContextChip is visible (wide web): chip (28) + gap (8) + btn (40) = 76.
 * Lead slot on mobile/narrow: avatar (24) + gap (4) + btn (30) = 58.
 */
export const WORLD_CUP_HEADER_LEAD_SLOT_PX = 76;
export const WORLD_CUP_HEADER_LEAD_SLOT_NARROW_PX = 58;

/**
 * Trail holds three buttons (standings, info, menu). These slot widths only set a
 * min-width on the wide trail container; the title is absolutely centred, so the
 * natural (wider) trail width just wins and centring is unaffected.
 */
export const WORLD_CUP_HEADER_TRAIL_SLOT_PX = 84;
export const WORLD_CUP_HEADER_TRAIL_SLOT_NARROW_PX = 30;
